export const messages = {
  required: 'To pole jest wymagane.',
  email: 'Niepoprawny adres email.'
};
